<div
  [ngClass]="{ 'datepicker--disabled': disabled(), 'datepicker--has-error': hasError() }"
  class="relative control-preview"
>
  <input-v2
    [formControl]="displayDateControl"
    class="datepicker special-control"
    [readonly]="true"
    [prependSrc]="'assets/img/calendar-v2-icon.svg'"
    [placeholder]="(title() ? title() : 'realizationTerm') | translate"
    (click)="datepicker.open(); $event.stopPropagation()"
  />

  <span
    *ngIf="dateControl?.value && !disabled() && clearable()"
    (click)="resetValue(); $event.stopPropagation()"
    aria-hidden="true"
    class="ng-clear"
  >
    ×
  </span>
</div>

<input
  matInput
  [matDatepicker]="datepicker"
  [matDatepickerFilter]="dateFilter"
  [formControl]="dateControl"
  [min]="getMinDate()"
  [max]="getMaxDate()"
/>

<mat-datepicker #datepicker />
